import { httpClient } from "../http/httpClient";
import { PartnerType } from "@/app/utils/partners.enum";

export type AuthorizationRequest = {
  name: string;
  cpf: string;
  email: string;
  birthDate: string;
  phone: string;
};

export type AuthorizationResponse = {
  id: string;
  link: string;
  expirationDate: string;
};

export async function postAuthorization(
  payload: AuthorizationRequest,
): Promise<AuthorizationResponse> {
  const { data } = await httpClient
    .post<AuthorizationResponse>("/c6/authorization", payload, {
      journey: PartnerType.C6,
    })
    .catch((error) => {
      throw error.response?.data ?? error;
    });

  return data;
}
